//	+-----------------------------------------------+
//	| DfPE router objects                           |
//	+-----------------------------------------------+

/**
 * @file routers.js
 * @desc contains the routers module
 * @author Geoffrey Pursell
 */

/* global workspace */

define('router',[
	// libraries
	"jquery", "underscore", "backbone", "cardboard/jQMSetup",

	// app modules
	"cardboard/router", "cardboard/util"
],
function ($, _, Backbone, jQueryMobileSetup,
		 CardboardRouter, Util) {

	/**
	 * @exports router
	 * @desc DfPE router objects: Contains the router objects that map
	 * URLs to application flow
	 */
	var AppRouter;

	console.log("MODULE: router");


	/**
	 * @class AppRouter
	 * @classdesc The main application router. As far as I know, this will be
	 * the only one we need for this app. It deals with URL changes that happen
	 * on page load, or back/forward browser buttons.
	 * @augments CardboardRouter
	 */

	AppRouter = CardboardRouter.extend(/** @lends AppRouter.prototype */{
	});

	return AppRouter;
});

